<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { categoryApiImpl } from '../composables/useMenuDesignServices'
import { menuApi } from '../composables/useMenuDesignServices'
import { MenuCategoryPage } from '@myorg/menu-editor-lib'
import type { RouteRecordRaw } from 'vue-router'
import { MenuEditorPage, MenuItem, CategoryData } from '@myorg/menu-editor-lib'
import { CategoryManagerPage } from '@myorg/menu-editor-lib'


import { ref, onMounted } from 'vue'

const { t } = useI18n();

// Shared State
const merchantId = ref("78f7d85e-79a6-49fe-b1a9-c215f4c5ce0a")
const rawItems = ref<MenuItem[]>([])
const categories = ref<CategoryData[]>([])

// Shared Sync Function
const syncAll = async () => {
  try {
    const [menuRes, catRes] = await Promise.all([
      await menuApi.getMenu(),
      await categoryApiImpl.fetchCategories()
    ])
    rawItems.value = menuRes
    categories.value = catRes
  } catch (err) {
    console.error("Sync failed", err)
  }
}

onMounted(syncAll)
</script>

<template>
  <div class="flex flex-col gap-6 p-4 sm:p-6">

    <nav class="flex items-center gap-4">
      <router-link to="/all_order" class="nav-link">
        <span class="icon">📋</span> {{ t('menuDesign.backToOrderManagement') }}
      </router-link>

      <a href="https://www.youtube.com/shorts/Q1ts64enV0c" target="_blank" rel="noopener" class="nav-link video-link">
        <span class="icon">▶</span> {{ t('menuDesign.tutorialVideo') }}
      </a>
    </nav>

    <MenuEditorPage :items="rawItems" :api="menuApi" @refresh="syncAll" />

    <CategoryManagerPage :categoryApi="categoryApiImpl" :merchantId="merchantId" @saved="syncAll" />

    <MenuCategoryPage :menuCategoryApi="categoryApiImpl" :menuItems="rawItems" :categoryItems="categories"
      @updated="syncAll" />

  </div>
</template>

<style scoped>
.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  border-radius: 0.75rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #374151;
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.nav-link:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-1px);
}

.video-link {
  background-color: #ef4444;
  /* YouTube Red */
  color: white;
  border-color: #dc2626;
}

.video-link:hover {
  background-color: #dc2626;
  color: white;
}

.router-link-active {
  background-color: #2563eb;
  color: white;
  border-color: #1d4ed8;
}

.icon {
  font-size: 1.1rem;
}
</style>